export function getImageAttributes(config, sourceWidth, sourceHeight) {
  if (config.type === "single") {
    if (config.height) {
      return {
        width: config.width,
        height: config.height
      };
    } else if (config.aspectRatio) {
      return {
        width: config.width,
        height: Math.round(config.width / config.aspectRatio)
      };
    }
    if (sourceWidth && sourceHeight) {
      const originalAspectRatio = sourceWidth / sourceHeight;
      return {
        width: config.width,
        height: Math.round(config.width / originalAspectRatio)
      };
    }
  }
  if (sourceWidth && sourceHeight) {
    if (config.aspectRatio) {
      return {
        width: sourceWidth,
        height: Math.round(sourceWidth / config.aspectRatio)
      };
    }
    return {
      width: sourceWidth,
      height: sourceHeight
    };
  }
}
